import { Breadcrumbs, Link, Typography } from "@mui/material";
import { useLocation, Link as RouterLink } from "react-router-dom";

const pathToNameMap: { [key: string]: string } = {
  actions: "Actions",
  admin: "Admin",
  approvals: "Approvals",
  automations: "Automations",
  catalog: "Catalog",
  contracts: "Contracts",
  data: "Data",
  datasets: "Datasets",
  developer: "Developer",
  employees: "Employees",
  ext: "Extensions",
  hooks: "Hooks",
  login: "Login",
  logout: "Logout",
  logs: "Logs",
  metrics: "Metrics",
  profile: "Profile",
  requests: "Requests",
  roles: "Roles",
  schedule: "Schedule",
  tasks: "Tasks",
  tools: "Tools",
  users: "Users",
};

function Navigation() {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((pn) => pn);

  if (pathnames.length === 0) return <></>;

  return (
    <Breadcrumbs>
      <Link component={RouterLink} underline="hover" to="/">
        Home
      </Link>
      {pathnames.map((value, index) => {
        const last = index === pathnames.length - 1;
        const to = `/${pathnames.slice(0, index + 1).join("/")}`;

        return last ? (
          <Typography color="text.primary" key={to}>
            {pathToNameMap[value] || value}
          </Typography>
        ) : (
          <Link component={RouterLink} underline="hover" to={to} key={to}>
            {pathToNameMap[value] || value}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
}

export default Navigation;
